import { ZoneMasterThemeSizeConfig } from './types';

const small: ZoneMasterThemeSizeConfig = {
  zoneMaster: {},
};

export default small;
